export default __webpack_public_path__ + "static/media/ic-microphone-permission.a68dcd7e.svg";